<template>
  <div
    class="media-preview-image"
    :style="previewStyle"
    data-testid="mediaPreviewImage-container"
  >
    <div
      v-if="isLoading"
      class="media-preview-image__loading d-flex align-center justify-center"
      data-testid="mediaPreviewImage-state-loading"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="28"
        width="3"
        data-testid="mediaPreviewImage-loader"
      />
    </div>

    <ImageMedia
      :key="imageKey"
      :src="src"
      :height="height"
      class="media-preview-image__image media-preview-image__image--contained"
      data-testid="mediaPreviewImage-image"
      @loaded="handleLoaded"
      @error="handleLoaded"
    />
  </div>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'

export default {
  name: 'MediaPreviewImage',

  components: {
    ImageMedia,
  },

  props: {
    src: {
      type: [Object, String],
      default: null,
    },
    height: {
      type: [String, Number],
      default: 200,
    },
  },

  data() {
    return {
      isLoading: true,
    }
  },

  computed: {
    imageKey() {
      return [this.src?.id, this.src?._id, this.src?.url, this.src]
        .filter(Boolean)
        .join(':')
    },

    normalizedHeight() {
      return typeof this.height === 'number' ? `${this.height}px` : this.height
    },

    previewStyle() {
      return {
        height: this.normalizedHeight,
        maxWidth: '420px',
        margin: '0 auto',
      }
    },
  },

  watch: {
    imageKey: {
      immediate: true,
      handler() {
        this.isLoading = Boolean(this.imageKey)
      },
    },
  },

  methods: {
    handleLoaded() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.media-preview-image {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: $color-white;
}

.media-preview-image__image {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.media-preview-image__image--contained {
  ::v-deep .image-media__img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: 100%;
    object-fit: contain;
    object-position: center;
    background-color: $color-white;
    margin: 0 auto;
  }

  ::v-deep .v-skeleton-loader,
  ::v-deep .v-skeleton-loader__image {
    width: 100% !important;
    height: 100% !important;
  }
}

.media-preview-image__loading {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(
    135deg,
    rgba($color-white, 0.96),
    rgba($color-white, 0.84)
  );
}
</style>
